import { useMemo } from 'react';
import {
	PlanWrapper,
	Border,
	Text,
	TextWrapper,
	TextTitle,
	SpanTitle,
} from './plan.styles';
import { useLanguageData } from '@/common/hooks/useLanguageData';

const TEXT_CONFIG = {
	pre: 'Dołącz do',
	preColor: ' 50.000',
	post: 'użytkowników, którzy już osiągają swoje cele ',
	postColor: 'z Synthi AI',
};

const Plan = ({ promo, selectedOption }) => {
	const translations = useLanguageData('checkout');

	const displayData = useMemo(() => {
		const result = {
			label: selectedOption?.inAppPrice?.label,
			originalPrice: selectedOption?.inAppPrice?.orginal_full_price,
			discount: selectedOption?.inAppPrice?.discount_label,
			discountValue: selectedOption?.inAppPrice?.discount_value,
			sum: selectedOption?.full_price,
			sumDiscountText: selectedOption?.inAppPrice?.saving,
		};

		if (promo) {
			result.discount = selectedOption?.inAppPrice?.promo_discount_label;
			result.discountValue = selectedOption?.inAppPrice?.promo_discount_value;
			result.sumDiscountText = selectedOption?.inAppPrice?.promo_saving;
			result.sum = selectedOption?.promo_full_price;
		}

		return result;
	}, [selectedOption, promo]);

	return (
		<PlanWrapper>
			<TextTitle>
				<span>{TEXT_CONFIG.pre}</span>
				<SpanTitle>{TEXT_CONFIG.preColor} </SpanTitle>
				<span>{TEXT_CONFIG.post} </span>
				<SpanTitle>{TEXT_CONFIG.postColor}</SpanTitle>
			</TextTitle>
			<TextWrapper style={{ marginTop: '22px' }}>
				<Text>
					<b>{displayData.label}</b>
				</Text>
			</TextWrapper>
			<TextWrapper style={{ marginTop: '15px' }}>
				<Text>Cena </Text>
				<Text>{displayData.originalPrice}</Text>
			</TextWrapper>
			<TextWrapper style={{ marginTop: '5px' }}>
				<Text>{displayData.discount}</Text>
				<Text style={{ color: '#D80027' }}>{displayData.discountValue}</Text>
			</TextWrapper>
			<Border style={{ margin: '10px 0 12px 0' }} />
			<TextWrapper>
				<Text>
					<b>{translations.total}</b>
				</Text>
				<div
					style={{
						display: 'flex',
						flexDirection: 'column',
						alignItems: 'flex-end',
					}}
				>
					<Text>
						<b>{displayData.sum} ZŁ</b>
					</Text>
					<Text
						style={{ fontSize: '10px', color: '#D80027', marginTop: '5px' }}
					>
						{displayData.sumDiscountText}
					</Text>
				</div>
			</TextWrapper>
		</PlanWrapper>
	);
};

export default Plan;
